import {connect} from "react-redux";
import LogsViewDetails from "./LogsViewDetails";
import {bindActionCreators} from "redux";
import { documentUploadUrlPublic } from "../../service/fileUpload/action";
import { regularizationDetailsForManager, regularizeAttendance } from "../../service/DarwinAttendance/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    regularizationDetails: state.DarwinAttendanceSync.regularizationDetails,
    approveRejectRegularization: state.DarwinAttendanceSync.approveRejectRegularization
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            regularizationDetailsForManager,
            regularizeAttendance
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LogsViewDetails);
